var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.522-185.087h44.565L672.26-627.26l-43.435-44-444.303 442.738v43.435Zm-78.653 79.218v-155.132l573.869-573.434q8.566-9.131 20.897-14.196 12.332-5.065 25.625-5.065 12.131 0 24.261 5.065 12.131 5.065 22.827 13.63l62.653 60.958q9.565 10.695 14.13 23.109 4.565 12.413 4.565 25.108 0 12.696-5.065 25.327-5.065 12.63-13.63 21.761L261.566-105.869H105.869Zm664.087-620.957-41.565-42.13 41.565 42.13Zm-119.131 77.001-22-21.435 43.435 44-21.435-22.565Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/edit-d8afe34b.svg";
export { SvgEdit as ReactComponent };